import React, { useEffect, useRef, useState } from "react";
import { ILogin, IPermissionProps } from "../../models/Login";
import { IModel } from "./LegalTaskManagement";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { baseUrl, Fetch } from "../../shared/Fetch";
import LegalTaskHistory from "../showPurchaseOrder/LegalTaskHistory";
import { Dialog } from "primereact/dialog";
import { useForm } from "react-hook-form";
import { IUsersDropdown } from "../../models/IDropdown";
import { Button } from "primereact/button";
import { JVDropdown } from "../../shared/JVDropdown";
import { safeFormatDate } from "../../models/DateFormatMapper";
import { ILegalTeamMast } from "../legalTeamManagment/Table";
import { InputTextarea } from "primereact/inputtextarea";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Accordion, AccordionTab } from "primereact/accordion";
import Filter, { EmptyFilterLegalTask, IFilterLegalTask } from "./Filter";
import { FileUpload, FileUploadHandlerParam } from "primereact/fileupload";
import { Toolbar } from "primereact/toolbar";

interface IProps {
  setModal: (modal: IModel) => void;
  toast: any;
  permissions: IPermissionProps;
  reload: boolean;
}

interface IStatusForm {
  status: string | null;
}

const statusSchema = yup.object({
  status: yup.string().required("Status is required"),
});

interface ILegal_Tasks {
  assignedBy?: string;
  assignedTo?: string;
  assigned_To?: number;
  assignee_Action_Reason?: string;
  assignee_Action_Status?: boolean;
  consultant?: string;
  created_At?: Date | string;
  created_By?: string;
  document_Name?: string;
  document_Type?: string;
  pO_Date?: Date | string;
  pO_ID?: number;
  pO_Status?: string;
  recruiter?: string;
  reqId?: number;
  saleManger?: string;
  status?: string;
  task_Id?: number;
  task_Name?: string;
  assigned_At?: string;
  assigne_Action_At?: string;
  can_Assign?: boolean;
  description?: string;
}

const Table = (props: IProps) => {
  const [historyModal, setHistoryModal] = useState(false);
  const [selectedTaskId, setSelectedTaskId] = useState<number | null>(null);
  const [openAssigned, setOpenAssigned] = useState<boolean>(false);
  const [legal_Team, setLegal_Team] = useState<ILegalTeamMast[]>([]);
  const [legalUsers, setLegalUsers] = useState<IUsersDropdown[]>([]);
  const [selectedTask, setSelectedTask] = useState<any>(null);
  const [statusModal, setStatusModal] = useState({ open: false, row: null as any });
  const [filters, setFilters] = useState<IFilterLegalTask>(EmptyFilterLegalTask);
  const [approvalDialog, setApprovalDialog] = useState({ open: false, rowData: null as any, action: null as "approve" | "reject" | null, reason: "" });
  const [supportiveDoc, setSupportiveDoc] = useState<File | any | null>(null);
  const [supportiveDocText, setSupportiveDocText] = useState<string>("");
  const [statusCounts, setStatusCounts] = useState<Array<{ status?: string; count?: number }>>([]);
  const [descriptionDialog, setDescriptionDialog] = useState({ visible: false, description: "" });
  const [reasonDialog, setReasonDialog] = useState({ visible: false, reason: "", title: "" });
  const dt = useRef<any>(null);
  const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<ILegal_Tasks>; loading: boolean });
  const loginObj: ILogin = JSON.parse(sessionStorage.getItem("auth") + "");
  const DateFormat = loginObj.date_Format;
  const roles = loginObj.roles.map((r: any) => r.role_ID);
  const loginId = loginObj.id;

  const { control, handleSubmit, reset, watch } = useForm({ defaultValues: { team_ID: null, AssignedTo: null } });

  const {
    control: statusControl,
    handleSubmit: handleStatusSubmit,
    setValue: setStatusValue,
    reset: resetStatus,
    formState: { errors },
  } = useForm<IStatusForm>({
    resolver: yupResolver(statusSchema),
    defaultValues: { status: "" },
  });

  const fileUploade = async (event: FileUploadHandlerParam) => {
    if (event.files[0].size > 1024000) {
      props.toast.current.show({ severity: "error", content: "Document should be less than 2 MB." });
      event.options.clear();
    } else {
      props.toast.current.show({ severity: "success", content: "Document Selected." });
      const file = event.files[0];
      setSupportiveDoc(file);
    }
  };

  const saveStatus = async (data: IStatusForm) => {
    if (data.status === "Closed" && statusModal.row.status !== "Approved") {
      props.toast.current.show({ severity: "warn", summary: "Warning", detail: "Task Can Not be Marked as Task Completed untill approved" });
      return;
    }
    if ((statusModal.row.status === "Escalated" || statusModal.row.status === "Completed") && !(roles.includes(1) || roles.includes(26))) {
      props.toast.current.show({ severity: "warn", summary: "Warning", detail: "only Management can do changes now" });
      return;
    }
    const formData = new FormData();
    formData.append("spDoc", supportiveDoc);
    const forBody: any = { ...data, Task_Id: statusModal.row?.task_Id, supportive_Text: supportiveDocText };
    formData.append("body", JSON.stringify(forBody));
    const params = {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("auth") + "")?.token}`,
      },
      body: formData,
    };

    const response = await fetch(`${baseUrl}Legal_Task/updateStatus`, params);

    if (response.status === 404) {
      const message = await response.text();
      props.toast.current.show({ severity: "error", detail: message, life: 3000 });
      return;
    }
    if (response.status === 400) {
      const message = await response.text();
      props.toast.current.show({ severity: "error", detail: message, life: 3000 });
      return;
    }

    if (response.ok) {
      props.toast.current.show({ severity: "success", detail: "Status Updated Successfully", life: 3000 });
      setStatusModal({ open: false, row: null });
      resetStatus();
      setSupportiveDoc(null);
      setSupportiveDocText("");
      loadTableData();
    }

    setStatusModal({ open: false, row: null });
    resetStatus();
  };

  const openApprovalDialog = (rowData: any, action: "approve" | "reject") => {
    setApprovalDialog({
      open: true,
      rowData,
      action,
      reason: "",
    });
  };
  const saveApproval = async () => {
    if (approvalDialog.action === "reject" && (approvalDialog.reason === undefined || approvalDialog.reason === null || approvalDialog.reason.trim() === "")) {
      props.toast.current.show({
        severity: "error",
        detail: "Reject Reason is required",
      });
      return;
    }

    const response = await Fetch("Legal_Task/approve", "POST", { taskId: approvalDialog.rowData.task_Id, action: approvalDialog.action, reason: approvalDialog.reason }, null, props.toast);

    if (response?.ok) {
      props.toast.current.show({ severity: "success", detail: `Task ${approvalDialog.action === "approve" ? "approved" : "rejected"} successfully` });

      setApprovalDialog({ open: false, rowData: null, action: null, reason: "" });

      loadTableData();
    }
  };

  const loadTeam = async () => {
    const response = await Fetch("LegalTeam_Mast/getAllLegalTeams", "GET", null, null, props.toast);

    if (response) {
      const data = await response.json();
      setLegal_Team(data);
    }
  };

  const loadLegalUsers = async (companyId: number, branchId: number, teamId: number) => {
    let query = "";
    if (teamId !== undefined && teamId !== null && teamId > 0) {
      query = `team_ID=${teamId}`;
    } else if (branchId !== undefined && branchId !== null && branchId > 0) {
      query = `branch_ID=${branchId}`;
    } else if (companyId !== undefined && companyId !== null && companyId > 0) {
      query = `company_ID=${companyId}`;
    }

    const response = await Fetch("Legal_Task/legalUsers", "GET", null, query, props.toast);

    if (response) {
      const data = await response.json();
      setLegalUsers(data);
    }
  };
  const openAssignDialog = (rowData: any) => {
    setSelectedTask(rowData);
    setOpenAssigned(true);
  };
  useEffect(() => {
    loadTeam();
  }, []);

  const teamId = watch("team_ID");

  useEffect(() => {
    if (teamId) {
      loadLegalUsers(0, 0, teamId);
    }
  }, [teamId]);

  const header = (
    <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
      <h5 className="m-0">Legal Task Management</h5>
    </div>
  );
  const loadTableData = async () => {
    setTableData((prev) => ({ ...prev, loading: true }));

    try {
      const response = await Fetch("Legal_Task/getLegalTask", "GET", null, `filter=${JSON.stringify(filters)}`, props.toast);

      if (response && response.ok) {
        const data = await response.json();

        setTableData({ tableData: data, loading: false });
      }
    } catch (error) {
      setTableData((prev) => ({ ...prev, loading: false }));
    }
  };

  const openHistory = (taskId: number) => {
    setSelectedTaskId(taskId);
    setHistoryModal(true);
  };

  const onHide = () => {
    reset({
      team_ID: null,
      AssignedTo: null,
    });
    setOpenAssigned(false);
  };

  const onSave = async (data: any) => {
    const response = await Fetch(
      "Legal_Task/assign",
      "POST",
      {
        taskId: selectedTask.task_Id,
        assignedTo: data.AssignedTo,
      },
      null,
      props.toast,
    );

    if (response?.ok) {
      props.toast.current.show({ severity: "success", summary: "Success", detail: "Task assigned successfully" });
      setOpenAssigned(false);
      loadTableData();
    }
  };

  useEffect(() => {
    loadTableData();
    loadStatusCounst();
  }, [props.reload, filters]);

  const StatusOptions = [
    { name: "Pending", value: "Pending" },
    // { name: "Assigned", value: "Assigned" },
    { name: "Received", value: "Received" },
    { name: "Under Review", value: "Under Review" },
    { name: "Fizzled Out", value: "Fizzled Out" },
    { name: "Negotiation in Progress", value: "Negotiation in Progress" },
    { name: "Documentation Pending", value: "Documentation Pending" },
    { name: "Executed", value: "Executed" },
    { name: "Escalated", value: "Escalated" },
    { name: "Completed", value: "Completed" },
    { name: "Approved", value: "Approved" },
    { name: "Rejected", value: "Rejected" },
    { name: "Closed", value: "Closed" },
  ];

  const loadStatusCounst = async () => {
    const resp = await Fetch("Legal_Task/getCounts", "GET", null, null, props.toast);
    if (resp) {
      const data: { status?: string; count?: number }[] = await resp?.json();
      setStatusCounts(data);
    }
  };

  const rightToolbarTemplate = () => {
    return (
      <React.Fragment>
        {statusCounts.map((el: { status?: string; count?: number }) => (
          <Button label={el.status + " → " + el.count} className="mr-1" />
        ))}
      </React.Fragment>
    );
  };

  return (
    <>
      <Toolbar className="mb-1 py-0" right={rightToolbarTemplate}></Toolbar>
      <Accordion>
        <AccordionTab header="Filter">
          <Filter filters={filters} setFilters={(filters: IFilterLegalTask) => setFilters(filters)} />
        </AccordionTab>
      </Accordion>
      <DataTable style={{ border: "1px solid rgba(105,105,105,0.17)", borderTopWidth: "0", marginTop: "5px" }} size="small" stripedRows showGridlines responsiveLayout="scroll" value={tableData.tableData} header={header} loading={tableData.loading} ref={dt}>
        <Column header="SN" body={(rowData, { rowIndex }) => rowIndex + 1} />
        <Column field="reqId" header="Req ID" />
        <Column field="saleManger" header="Sales Manager" />
        <Column field="recuriter" header="Recuriter" />
        <Column field="consultant" header="Consultant Name" />
        <Column field="pO_Date" header="PO Date" style={{ minWidth: "7rem" }} body={(rowData: any) => <span>{safeFormatDate(rowData.pO_Date, "dd/MM/yyyy", DateFormat)}</span>} />
        <Column field="pO_Status" header="PO Status" />
        <Column field="task_Name" header="Task Name" />
        <Column
          header="Description"
          body={(rowData: ILegal_Tasks) =>
            rowData.description ? (
              <i className="pi cursor-pointer underline" style={{ color: "var(--primary-color)" }} onClick={() => setDescriptionDialog({ visible: true, description: rowData?.description || "" })}>
                View Description
              </i>
            ) : (
              "-"
            )
          }
        />
        <Column field="document_Type" header="Document Type" />
        <Column field="document_Name" header="Document Name" />
        <Column
          header="Status"
          body={(rowData: ILegal_Tasks) => {
            return rowData?.assigned_To === undefined || rowData?.assigned_To === null ? (
              <b> Created</b>
            ) : rowData?.status === "Closed" && !(roles.includes(1) || roles.includes(26)) ? (
              <p onClick={() => props.toast.current.show({ severity: "warn", summary: "Warning", detail: "Closed" })}>{rowData?.status || ""}</p>
            ) : (rowData?.status === "Escalated" || rowData?.status === "Completed") && !(roles.includes(1) || roles.includes(26)) ? (
              <p onClick={() => props.toast.current.show({ severity: "warn", summary: "Warning", detail: "only Management can do changes now" })}>{rowData?.status || ""}</p>
            ) : rowData?.assignee_Action_Status === true ? (
              <span
                className="cursor-pointer text-cyan-700 underline"
                onClick={() => {
                  setStatusValue("status", rowData?.status || "");
                  setStatusModal({ open: true, row: rowData });
                }}
              >
                {rowData?.status !== "Pending" ? rowData?.status : "Assigned"}
              </span>
            ) : rowData?.assignee_Action_Status === undefined || rowData?.assignee_Action_Status === null ? (
              <b>Waiting For Assigne For Acceptance</b>
            ) : rowData?.assignee_Action_Status === false ? (
              <p>Task will be reassign</p>
            ) : (
              <p>Task Created, Not Yet Assigned</p>
            );
          }}
        />
        <Column field="assignedTo" header="Assigned To" />
        <Column
          header="Assignee Approval Status"
          style={{ minWidth: "250px" }}
          body={(rowData: ILegal_Tasks) => {
            const pending = rowData?.assignee_Action_Status === null || rowData?.assignee_Action_Status === undefined;

            const rejected = rowData?.assignee_Action_Status === false;

            if (rejected) {
              return (
                <div className="flex flex-column gap-1">
                  <span className="font-bold" style={{ color: "red" }}>
                    ✘ Rejected
                  </span>

                  {rowData.assignee_Action_Reason && (
                    <span
                      className="mt-1 p-button-sm p-link text-blue-500 cursor-pointer"
                      onClick={() =>
                        setReasonDialog({
                          visible: true,
                          reason: rowData.assignee_Action_Reason || "",
                          title: "Rejection Reason",
                        })
                      }
                    >
                      View Reason
                    </span>
                  )}
                </div>
              );
            }

            if (!pending) {
              return <span className="text-green-500 font-bold w-full">✔ Accepted</span>;
            }

            if (rowData.assigned_To === loginId) {
              return (
                <div className="flex flex gap-2">
                  <Button tooltip="Accept" icon="pi pi-check" className="p-button-success p-button-sm" onClick={() => openApprovalDialog(rowData, "approve")} />
                  <Button tooltip="Reject" icon="pi pi-times" className="p-button-danger p-button-sm" onClick={() => openApprovalDialog(rowData, "reject")} />
                </div>
              );
            }

            const diffMs = new Date().getTime() - new Date(rowData.assigned_At || "").getTime();

            const totalMinutes = Math.floor(diffMs / (1000 * 60));

            return (
              <span className="text-yellow-500 font-bold flex w-full">
                <span>⏳ Pending</span> {rowData.assigned_At !== null && <p>{`( ${totalMinutes}m )`}</p>}
              </span>
            );
          }}
        />
        <Column field="assignedBy" header="Assigned By" />
        <Column field="created_At" header="Created At" style={{ minWidth: "7rem" }} body={(rowData: any) => <span>{safeFormatDate(rowData.created_At, "dd/MM/yyyy", DateFormat)}</span>} />
        <Column field="created_By" header="Created By" />
        <Column
          header="History"
          body={(rowData) => (
            <span className="cursor-pointer" onClick={() => openHistory(rowData.task_Id)}>
              <i className="pi pi-history" style={{ color: "var(--primary-color)" }} />
            </span>
          )}
        />
        <Column
          header="Action"
          body={(rowData: ILegal_Tasks) =>
            rowData.can_Assign === true ? (
              <span className="cursor-pointer" onClick={() => openAssignDialog(rowData)}>
                <i className="pi pi-pencil" style={{ color: "var(--primary-color)" }} />
              </span>
            ) : (
              <></>
            )
          }
        />
      </DataTable>
      {/* Assign TasK */}
      <Dialog visible={openAssigned} modal header="Assign Task" style={{ width: "80vw" }} onHide={onHide}>
        <form onSubmit={handleSubmit(onSave)}>
          <div className="p-fluid formgrid grid">
            <JVDropdown column={3} label="Team" control={control} name="team_ID" options={legal_Team} optionLabel="team_Name" optionValue="team_ID" placeholder="Select Legal Team" />
            <JVDropdown column={3} label="Assigned To" control={control} name="AssignedTo" options={legalUsers} optionLabel="user_Name" optionValue="login_ID" placeholder="Select Legal User" />

            <div className="col-12 flex justify-content-end gap-2">
              <Button
                type="button"
                label="Clear"
                className="p-button-outlined"
                onClick={() =>
                  reset({
                    team_ID: null,
                    AssignedTo: null,
                  })
                }
              />

              <Button type="submit" label="Save" />
            </div>
          </div>
        </form>
      </Dialog>
      {/* Approval Dialog */}
      <Dialog
        visible={approvalDialog.open}
        modal
        onHide={() =>
          setApprovalDialog({
            open: false,
            rowData: null,
            action: null,
            reason: "",
          })
        }
        header={approvalDialog.action === "approve" ? "Approve Task" : "Reject Task"}
        style={{ width: "25vw" }}
      >
        <p>Are You Sure You {approvalDialog.action === "approve" ? "Can" : "Can Not"} Complete This Task</p>

        <div>
          <label>{approvalDialog.action === "approve" ? "Remark If Any" : "Reject Reason"}</label>
          <InputTextarea
            value={approvalDialog.reason}
            onChange={(e: any) =>
              setApprovalDialog((prev) => ({
                ...prev,
                reason: e.target.value,
              }))
            }
            rows={3}
            className="w-full"
            placeholder="Enter Comment"
          />
        </div>

        <div className="flex justify-content-end mt-3">
          <Button label={approvalDialog.action === "approve" ? "Accept" : "Reject"} onClick={saveApproval} />
        </div>
      </Dialog>
      {/* Reason Block */}
      <Dialog
        visible={reasonDialog.visible}
        modal
        header={reasonDialog.title}
        style={{ width: "30vw" }}
        onHide={() =>
          setReasonDialog({
            visible: false,
            reason: "",
            title: "",
          })
        }
      >
        <p>{reasonDialog.reason}</p>
      </Dialog>
      {/* Status Dialog   */}
      <Dialog
        visible={statusModal.open}
        header="Update Status"
        style={{ width: "30vw" }}
        modal
        onHide={() => {
          setStatusModal({ open: false, row: null });
          setSupportiveDoc(null);
          setSupportiveDocText("");
          resetStatus();
        }}
      >
        <form onSubmit={handleStatusSubmit(saveStatus)}>
          <div className="p-fluid formgrid grid">
            <JVDropdown
              column={2}
              label="Status"
              control={statusControl}
              name="status"
              options={roles.includes(1) || roles.includes(26) ? StatusOptions : statusModal.row?.status === "Approved" ? StatusOptions.filter((el: any) => el.name === "Closed") : StatusOptions.filter((fl: any) => fl.name !== "Approved" && fl.name !== "Rejected")}
              optionLabel="name"
              optionValue="value"
              error={errors.status?.message}
            />
            <div className="field col-12 md:col-6">
              <label htmlFor="file">Supportive Document</label>
              <FileUpload chooseLabel="Choose Document" mode="basic" name="file" accept="*" maxFileSize={10000000} auto customUpload uploadHandler={fileUploade} />
            </div>
            <div className="field col-12 md:col-12">
              {/* <label htmlFor="file">Supportive Reason<span style={{ color: 'red' }}>*</span></label> */}
              <label htmlFor="file">Supportive Reason</label>
              <InputTextarea value={supportiveDocText} onChange={(e) => setSupportiveDocText(e.target.value)} rows={5} cols={30} />
            </div>
            <div className="field col-12 flex justify-content-end gap-2">
              <Button label="Save" icon="pi pi-check" type="submit" />
              <Button label="Clear" icon="pi pi-times" type="button" className="p-button-secondary" onClick={() => setStatusValue("status", "")} />
            </div>
          </div>
        </form>
      </Dialog>
      {/* History Table */}

      <LegalTaskHistory
        visible={historyModal}
        taskId={selectedTaskId}
        toast={props.toast}
        onHide={() => {
          setHistoryModal(false);
          setSelectedTaskId(null);
        }}
      />
      {/* Description Box */}
      <Dialog header="Task Description" visible={descriptionDialog.visible} modal style={{ width: "40vw" }} onHide={() => setDescriptionDialog({ visible: false, description: "" })}>
        <p style={{ whiteSpace: "pre-wrap" }}>{descriptionDialog.description}</p>
      </Dialog>
    </>
  );
};

export default Table;
